import { Category } from "../..";
import Document from "./Document";

const { TabView, TabPanel } = require("primereact/tabview");

const CategoryManagement = () => {
  return (
    <div>
      <TabView>
        <TabPanel header="Danh sách dự án">
          <Category />
        </TabPanel>
        <TabPanel header="Tài liệu dự án">
          <Document />
        </TabPanel>
      </TabView>
    </div>
  );
};
export default CategoryManagement;
